<script setup lang="ts">
import chartIcon from "@/assets/images/chart.png";
import errorChartIcon from "@/assets/images/chart-error.png";

interface Icard {
  label: string;
  number: number;
  status?: "less" | "more";
  size?: "small" | "large";
  bg?: string;
}

const props = withDefaults(defineProps<Icard>(), {
  label: "",
  size: "small",
  status: "less",
  bg: "",
});
</script>
<template>
  <div class="c-cu-card" :class="[size, status]">
    <div class="card__header">
      <div class="card__header__info">
        <div
          class="card__header__info--label"
          :style="bg ? { backgroundColor: `var(${bg})` } : {}"
        >
          {{ label }}
        </div>
        <div class="card__header__info--number">{{ number }}</div>
      </div>
    </div>
    <div v-if="size === 'large'" class="card__body">
      <img v-if="status === 'more'" :src="chartIcon" alt="chart" />
      <img v-else :src="errorChartIcon" alt="chart-error" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.c-cu-card {
  border: 2px solid var(--color-border);
  border-radius: 14px;
  padding: 12px;
  height: 88px;
  width: 100%;
  cursor: pointer;
  position: relative;

  &.large {
    min-width: 250px;
  }

  .card__header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__info {
      &--label {
        font-size: 14px;
        line-height: 20px;
        font-weight: 500;
        color: var(--color-label);
        padding: 0 8px;
        margin-bottom: 8px;
        border-radius: 8px;
        white-space: nowrap;
        width: fit-content;
      }

      &--number {
        font-size: 24px;
        line-height: 32px;
        font-weight: 600;
        color: var(--color-label);
      }
    }
  }

  .card__body {
    position: absolute;
    bottom: 12px;
    right: 12px;
    height: 60px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top;
    }
  }
}
</style>
